import { SuggestedRouteEvents } from '../../local_modules/voyage-suggested-routes/src/types';
import { FloatPanelComponent } from '../../vessel/src/main-app';
import { UiStateModel, UiStateModelParam } from '../models/ui-state-model';
import { VesselPlanningModel, VoyagePlan } from '../models/vessel-planning-model';
import { VoyageRoutingModel } from '../models/voyage-routing-model';
import { WhaleZonesModel } from '../models/whale-zones-model';
import { ZoneFeature } from '../models/zones-base-interfaces';
import { WhaleZonesLayerBase } from './whale-zones-layer-base';

export class WhaleZonesLayerInForce extends WhaleZonesLayerBase {
    connectEventHandlers(): void {
        VesselPlanningModel!.addEventListener("executing-plan-changed", () => this.plotWhaleZones());
        VesselPlanningModel!.addEventListener(SuggestedRouteEvents.PlanChanged, () => this.plotWhaleZones());
        UiStateModel!.addEventListener(`${UiStateModelParam.ApplicationMode}-change`, () => this.plotWhaleZones());
    }
    
    async getZones(): Promise<ZoneFeature[] | null> {
        let zones: ZoneFeature[] | null = null;
        let plan: VoyagePlan | null = null;
        
        const mode: FloatPanelComponent = <FloatPanelComponent>UiStateModel!.getValue(UiStateModelParam.ApplicationMode);

        if (mode === "suggestedRoutes" || mode === "routeEditor") {
            const activePlan = VoyageRoutingModel!.activePlan;
            if (activePlan) {
                plan = await VesselPlanningModel!.getCurrentPlan(activePlan);
            }
        } else {
            plan = await VesselPlanningModel!.getExecutingPlan();
        }
        
        if (plan) {
            zones = await WhaleZonesModel!.allActiveZones(new Date(plan!.etd), new Date(plan!.eta));
            return zones;
        }

        // If there is no plan get the zones active 'now'
        const now = new Date();
        let tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        zones = await WhaleZonesModel!.allActiveZones(now, tomorrow);
        
        return zones ? zones : [];
    }
} 